<priva-dialog [hasFooter]="false" [title]="title || rowNumber.toString()" (close)="closeDialog()">
    <div class="content-wrapper">
        <priva-selection-group
            type="Radio"
            name="rowStatusOptions"
            theme="onwhite"
            prefix="Icon"
            [items]="rowStatusSelectItems"
            (toggle)="onToggle($event)"
            size="Md"
            data-test="row-status-select-group"
        />

        @if (showRemoveButton) {
            <button
                priva-button
                importance="secondary"
                status="danger"
                (click)="removeRow()"
                iconClass="fas fa-trash-can"
                iconState="left"
                data-test="remove-selected-row-btn"
            >
                {{ 'GENERAL.ACTION.REMOVE' | translate }}
            </button>
        }
    </div>
</priva-dialog>
